
const cancelamentoGridConfig = {
  idField: "idCancelamento",
  columns: [
    { header: "Data", field: "DATA" },
    { header: "Horário", field: "HORARIO", 
      formatter: (value) => value !== null && value !== undefined
        ? `${(value).slice(0,5)} h` : "-"
    },
    { header: "Motivo", field: "MOTIVO" },
    { header: "Cliente", field: "NOME" }
  ]
};

export default cancelamentoGridConfig;
